import { Paragraph } from '@quickmd-llc/design-system'
import { removeAllTags } from '../../utils'

type DrugScreenRequirementsProps = {
  stateName: string
  stateRulesHtml: string | undefined
  isLoading: boolean
}

export function DrugScreenRequirements({ stateName, stateRulesHtml, isLoading }: DrugScreenRequirementsProps) {
  const hasRules = Boolean(removeAllTags(stateRulesHtml ?? ''))
  return (
    <div className='mt-sp-2 flex flex-col gap-sp-1'>
      <Paragraph className='font-semibold text-text-dark'>Requirements</Paragraph>
      <div className='flex items-center gap-sp-1'>
        <Paragraph size='xs' className='font-semibold text-text-dark'>
          State:
        </Paragraph>
        <Paragraph size='xs' className='text-text-light'>
          {stateName}
        </Paragraph>
      </div>
      {isLoading ?
        <div data-testid='requirements-loading' className='h-[18px] w-[220px] animate-pulse rounded bg-border-light' />
      : hasRules ?
        <div
          className='text-[12px] leading-[18px] text-text-light [&_p]:m-0'
          // eslint-disable-next-line react/no-danger -- stateRulesHtml is admin-authored state cadence copy, not user input
          dangerouslySetInnerHTML={{ __html: stateRulesHtml ?? '' }}
        />
      : <Paragraph size='xs' className='text-text-light'>
          Regular drug screen not required by state
        </Paragraph>
      }
    </div>
  )
}
